import { defineMessages } from 'react-intl';

export default defineMessages({
  nowPlaying: {
    id: 'thumbnail.now-playing',
    defaultMessage: 'Now Playing',
  },
});



// WEBPACK FOOTER //
// ./src/widget/components/thumbnail/translations.js